import {
  getDefaultLanguageStore,
  getKeyVal,
  getLanguageCodes,
  getPostURL, getScanner,
  languageCodes,
  setKeyVal,
  translateString
} from '../../methods/helpers';

import {
  AppConfig,
  AppDesign,
  AppSettings,
  ElementDesign,
  GeneralState,
  State
} from '../../interfaces/biozoom-api/app-configuration';
import { environment } from '../../../environments/environment';
import { genElements } from '../../methods/gen-html';
import { of, pipe, Subscription } from 'rxjs';
import {sendLogs, sendLogsSystem} from '../../methods/send-logs';
import { AoxMeasurementResult } from '../../interfaces/biozoom-api/aox-measurement-result';
import { PipelineStageConfig, ResultType, StatusObject } from '../../interfaces/biozoom-api/pipeline';
import { ScannerStatus } from '../../interfaces/scanner-api/scanner-status';
import { HrvMeasurementData } from '../../interfaces/biozoom-api/hrv-measurement-data';
import { fillConfig } from '../../methods/templateUtils';
import { Storage } from '@ionic/storage';
import { getResult } from '../../methods/result';
import { Scanner } from '../../interfaces/scanner-api/scanner';
import {
  ActionSheetController,
  AlertController,
  ModalController, Platform,
  PopoverController,
  ToastController
} from '@ionic/angular';
import { ScannerApiService } from '../../services/scanner/scanner-api.service';
import { ApiBasicService } from '../../services/api/api-basic.service';
import { GenConfigService } from '../../services/gen-config.service';
import { NetworkService } from '../../services/network.service';
import { Network } from '@ionic-native/network/ngx';
import { Router } from '@angular/router';
import { Insomnia } from '@ionic-native/insomnia/ngx';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
import { WindowObservablesService } from '../../services/window-observable';
import { UsbApiService } from '../../services/scanner/usb-api.service';
import { UsbApiService2 } from '../../services/scanner/usb-api2.service';
import { ChangeDetectorRef } from '@angular/core';
import { ScreenOrientation } from '@awesome-cordova-plugins/screen-orientation/ngx';
import { NavigationBar } from '@ionic-native/navigation-bar/ngx';
import { AndroidFullScreen } from '@awesome-cordova-plugins/android-full-screen/ngx';
import { FileManagerService } from '../../services/fileManager/file-manager.service';
import { throttle } from 'lodash';
import {License} from '../../interfaces/biozoom-api/license';
import {getLicense} from '../../methods/license';
import {clearAppLogs, readAppLogs, replaceAppLogs} from '../../services/app-log.service';

type HomePageProperties = {
  lastPage: string;
  progress: number[],
  barIsMeasured: boolean[],
  instructionLink: string,
  step: string,
  isElectron: boolean;
  currentDesign: string,
  elementConfig,
  setElementConfig: (elements, pageConfig?: Record<string, any>) => void,
  pageConfig: Record<string, any>,
  confirmed: boolean,
  pipelineType: any,
  state: GeneralState,
  windowDim: { w: number, h: number },
  languageStore: Record<string, string>,
  media: Record<string, string>,
  lastTS: number,
  videoFinished: boolean,

  serial: string,
  measurements: any[],
  numMeasurements: number,
  idx: number,
  timeout: number,
  aoxData: AoxMeasurementResult[],
  // input object for each pipeline stage
  stateObj: StatusObject,
  result: ResultType,
  STORAGE_ID: string,
  scanner: Scanner,
  lastTimeBackPress: number,
  timePeriodToExit: number,
  networkType: string,
  orientationLock: boolean,
  orientationValue: string,
  hrvProgress: number,
  hrvBarIsMeasured: boolean,
  blockScreen: boolean,
  hrvMeasurement: any,
  lastEnter: number,
  stageHistory: string[],
  lastRenderedPage: string,
  didPostIframe: boolean,
  lock: boolean,
  lastCheck: number,
  lastBackChecked: number,
  usbCheckUp: boolean,
  helperFunctions: any,

  alertCtrl: AlertController,
  actionSheetCtrl: ActionSheetController,
  popoverCtrl: PopoverController,
  modalCtrl: ModalController,
  toastCtrl: ToastController,
  scannerApi: ScannerApiService,
  apiBasicService: ApiBasicService,
  genConfigService: GenConfigService,
  appConfigService?: { load: (configName?: string, reset?: boolean, forceLicense?: boolean) => Promise<boolean> },
  networkService: NetworkService,
  network: Network,
  router: Router,
  // stateService: StateService,
  insomnia: Insomnia,
  platform: Platform,
  iab: InAppBrowser,
  windowService: WindowObservablesService,
  cd: ChangeDetectorRef,
  screenOrientation: ScreenOrientation,
  navbar: NavigationBar,
  afs: AndroidFullScreen,
  fileManager: FileManagerService,
  checkerDataService?: { isCheckerActive: boolean },
  navigate: ((url: string) => void);
};

export class HomePageHelpers {
  params: HomePageProperties;
  private subscriptions = new Subscription();
  private alive = true;
  private pageInit = 0;
  constructor(params: any) {
    this.params = params;
    this.throttledFn = throttle(this.setProgress, 100);
  }
  throttledFn: (idx: number, progress: number) => void;


  setAlive = (state: boolean) => {
    this.alive = state;
  }

  onKeyboardInput = (e: [string, any]) => {
    const val = this.params.elementConfig;
    this.handleFunction(val[e[1].id].handleFunction, e[0].toString());
  }

  /**
   * retrieve the title of an element
   * if the name contains a js-typed variable (${}), try to parse it and return the value instead
   * @param m element object the title of is to be returned
   */
  getKeyValParser = (m: ElementDesign) => {
    let val = m?.maintitle ?? '';
    if (val.startsWith('${')) {
      const valInner = val.replace('${', '').replace('}', '');
      const valSplit = valInner.split('.');
      if (valSplit.length > 1) {
        const group = valSplit[0];
        const key = valSplit.slice(1).join('');
        const newVal = getKeyVal(`${group}.${key}`, this.params.state);
        val = newVal ?? '';
      }
    }
    return val;
  }

  /**
   * retrieve the display-value of an element
   * this is done by retrieving a variable from the general key-val store
   * @param m element object the value of is to be returned
   */
  getKeyValWrapper = (m: ElementDesign) => {
    const group = m?.handleFunction?.group;
    const key = m?.handleFunction?.value;
    if (!group || !key) {
      return undefined;
    }
    let val = getKeyVal(`${group}.${key}`, this.params.state);
    if (val === undefined) {
      return val;
    }
    if (typeof val !== 'string') {
      if (typeof val !== 'object') {
        val = val.toString();
      } else {
        val = JSON.stringify(val);
      }
    }
    return val;
  }

  /**
   * check if a barcode input is rendered. if so, focus it.
   * otherwise, in case an element with the 'focus'-attribute is rendered, focus it
   */
  checkBarcode() {
    const elBarcode = document.getElementsByClassName('barcode')[0] as HTMLInputElement;
    if (elBarcode) {
      elBarcode.focus();
    } else {
      const elFocus = document.getElementsByClassName('focus')[0] as HTMLInputElement;
      if (elFocus) {
        elFocus.focus();
      }
    }
  }

  /**
   * select the topmost element of the given controller, and if it exists, dismiss it
   * @param controller controller that might own a dismissible element
   * @private
   */
  private async checkDismissableCtrl(controller: any) {
    try {
      const element = await controller.getTop();
      if (element && (element.backdropDismiss === undefined || element.backdropDismiss)) {
        await element.dismiss();
        return;
      }
    } catch (error) {
      console.log(error);
    }
  }

  /**
   * register the device's back-button
   * first, dismiss all overlays
   * then, register a timer. if the button is pressed again within 10 seconds, close the application
   */
  registerBackButtonEvent() {
    this.params.platform.backButton.subscribeWithPriority(10000, async () => {
      const ts = (new Date(Date.now())).getTime();
      if ((ts - this.params.lastBackChecked) < 100) {
        return;
      }
      this.params.lastBackChecked = ts;

      await this.checkDismissableCtrl(this.params.actionSheetCtrl);
      await this.checkDismissableCtrl(this.params.popoverCtrl);
      await this.checkDismissableCtrl(this.params.modalCtrl);
      await this.checkDismissableCtrl(this.params.alertCtrl);

      // close side menu
      if (this.params.step !== environment.appDesignSettings.homeStage) {
        // await this.networkService.disconnectScanner(this.state.persistentValues);
        this.resetPage(environment.appDesignSettings.homeStage);
        return;
      }

      if (this.params.router.isActive('/home', true)) {
        if (new Date().getTime() - this.params.lastTimeBackPress < this.params.timePeriodToExit) {
          // @ts-ignore
          navigator.app.exitApp(); // work for ionic 4

        } else {
          this.params.toastCtrl.create({
            message: this.translateWrapper('PRESS_BACK_AGAIN'),
            duration: 2000,
            position: 'bottom'
          }).then((toast) => {
            toast.present();
          });

          this.params.lastTimeBackPress = new Date().getTime();
          return;
        }
      }
    });
  }

  /**
   * validate whether the app and the scanner are set up properly
   * first, if no wifi registration is set up, attempt to establish a USB connection
   * otherwise, disconnect the scanner
   *
   * newer scanners might receive an ESP-update here
   * for newly paired scanners, load its config
   * validate whether an internet-connection can be established
   */
  stageValidator = async (): Promise<{status: boolean, message: string, nextStage: string}> => {
    // TODO: validate this
    const now = Date.now();
    if ((now - this.params.lastCheck) < 1000) {
      // return false;
    }
    this.params.lastCheck = now;
    this.params.state.persistentValues.CONFIG_NAME = environment.appDesignName;
    // if demo mode has been enabled, set the current connection type to demo
    if (this.params.state.persistentValues.DEMO_MODE) {
      this.setState(State.CONNECTION_TYPE, 'Demo');
    } else if (this.params.state.persistentValues.CONNECTION_TYPE === 'Demo') {
      this.params.state.persistentValues.CONNECTION_TYPE = '';
    }
    this.setState(State.USB_MODE, false);
    const serial = await this.checkUSBDevice();

    // if (Number(serial.slice(2, 4)) > 20 && this.params.apiBasicService.getConfiguration().shouldUpgradeESP) {
    //   this.setBlockScreen(true);
    //   const shouldRestart = await (this.params.scannerApi.updateESP(this.getArgs(), serial));
    //   this.setBlockScreen(false);
    //   if (shouldRestart) {
    //     return this.stageValidator();
    //   }
    // }

    const scanner = await getScanner(this.params.state.persistentValues, serial);
    if (scanner !== undefined && scanner.serial) {
      if (this.params.state.persistentValues.USB_MODE) {
        this.setState(State.SCANNER_SERIAL, scanner.serial);
      }
      this.params.scanner = scanner;
    }
    this.params.serial = this.params.scanner?.serial;

    // if a new usb scanner has been paired, load its config
    if (this.params.state.persistentValues.USB_MODE) {
      if (this.params.serial) {
        const flag = localStorage.getItem('serial');
        localStorage.setItem('serial', this.params.serial);
        if (!flag || flag !== this.params.serial) {
          return { status: false, nextStage: environment.appDesignSettings.updateStage, message: 'need to fetch config' };
        }
      }
    }

    // ensure a language is selected
    if (!this.params.state.persistentValues.SELECTED_LANGUAGE) {
      let languageCode = (Object.keys(languageCodes).find(e => e.toLowerCase() === (window?.navigator?.language ?? '').toLowerCase()));
      if (!languageCode) {
        languageCode = (Object.keys(languageCodes).find(e => e.toLowerCase().startsWith((window?.navigator?.language ?? '').toLowerCase().slice(0, 2))));
        if (languageCode === 'EN-GB') {
          languageCode = 'EN-US';
        }
      }
      if (languageCode) {
        this.setState(State.SELECTED_LANGUAGE, languageCode);
      } else {
        return { status: false, nextStage: environment.appDesignSettings.languageStage, message: 'missing language' };
      }
    }

    // if in Wi-Fi mode, disconnect the scanner
    // await this.params.networkService.disconnectScanner(this.params.state.persistentValues);
    await this.params.scannerApi.disconnectScanner(this.params.state.persistentValues);

    // check whether mobile devices have an active internet connection
    if (
      this.params.platform.is('cordova')
      && !(['Demo', 'WIFI'].includes(this.params.state.persistentValues.CONNECTION_TYPE))
    ) {
      if (this.params.network.type === 'none' && !(environment.appDesignSettings.offlineConfig)) {
        return { status: false, nextStage: environment.appDesignSettings.offlineStage, message: 'Device offline' };
      }
    }

    this.params.isElectron = this.params.platform.is('electron');

    if (
      (!this.params.state.persistentValues.DEMO_MODE
        && (environment?.appDesignSettings?.askForUSB === undefined
          || environment?.appDesignSettings?.askForUSB)
      )
    ) {
      // if no connection known, go to pairing-stage
      if (this.params.state.persistentValues.CONNECTION_TYPE === '' || !this.params.state.persistentValues.CONNECTION_TYPE || (!this.params.scanner && this.params.state.persistentValues.CONNECTION_TYPE === 'WIFI')) {
        return { status: false, nextStage: environment.appDesignSettings.setupStage, message: 'Not paired.' };
      }

      // if connection type is usb, but connection could not be established, go to error screen
      if (this.params.state.persistentValues.CONNECTION_TYPE === 'USB' && !this.params.state.persistentValues.USB_MODE) {
        return { status: false, nextStage: environment.appDesignSettings.reconnectStage, message: 'Can\'t connect.' };
      }
    }

    // if a scanner is paired, but no config is loaded, go to error screen
    if (!environment.appDesignName && !(this.params.state.persistentValues.DEMO_MODE)) {
      if (!scanner?.serial) {
        return { status: false, nextStage: environment.appDesignSettings.updateStage, message: 'Not paired' };
      } else {
        return { status: false, nextStage: environment.appDesignSettings.noConfigStage, message: 'No config loaded' };
      }
    }
    // this.params.state.persistentValues.CONNECTION_TYPE = 'USB';
    this.params.state.persistentValues.ALLOW_HRV =
      ((environment?.appDesignSettings?.allowHRV ?? true)
        && (
          this.params.state.persistentValues.SCANNER_VERSION === 2
          || this.params.state.persistentValues.CONNECTION_TYPE === 'WIFI'
        )
      );

    return { status: true, nextStage: '', message: '' };
  }

  /**
   * fetch all text-based elements, such as paragraphs or buttons
   * if they can not contain the text, shrink the text until it does
   */
  shrinkText = () => {
    const doesOverflow = (el: HTMLElement) => {
      const isOverflowing = el.clientWidth < el.scrollWidth
        || el.clientHeight < el.scrollHeight;
      return isOverflowing;
    };

    const els: HTMLElement[] = [].slice.call(document.getElementsByClassName('shrink'));
    for (const el of els) {
      if (el.nodeName === 'INPUT') {
        continue;
      }
      let size = parseInt(getComputedStyle(el).getPropertyValue('font-size'), 10);
      while (doesOverflow(el) && size > 0) {
        el.style.fontSize = size + 'px';
        size -= 1;
      }
    }
  }

  /**
   * recalculate the elements to display, based on the current stage
   * @param step name of the stage to execute
   */
  calcElements = async (step = this.params.step) => {
    const { elements: e, pageConfig: pC } = genElements(step, this.params.state, this.params.media);
    this.params.setElementConfig(e, pC);
    this.params.lastPage = step;
    await new Promise(a => setTimeout(a, 500));
    this.shrinkText();
  }

  setBlockScreen = (block: boolean) => {
    this.params.blockScreen = block;
  }

  /**
   * initialize all variables required for measurement
   * also attempt to fetch the scanner
   */
  initPage = async () => {
    this.params.lock = false;
    // new function should be called by this.params, and also by buttons such as language selection
    // if not usb, go to disabling window
    // if not language, go to language selection
    const stateRaw = localStorage.getItem('persistentValues');
    if (stateRaw) {
      this.params.state.persistentValues = JSON.parse(stateRaw);
    } else {
      this.params.state.persistentValues = {};
    }
    this.setState(
      State.IS_WEBAPP,
      !this.params.platform.is('cordova') && !this.params.platform.is('electron')
    );
    this.params.languageStore = environment.appDesignLanguages?.[this.params.state.persistentValues.SELECTED_LANGUAGE
      ?? this.params.apiBasicService.getConfiguration().defaultLang] ?? {};

    this.params.state.persistentValues.DEMO_MODE = false;
    this.params.state.persistentValues.OS = this.params.apiBasicService.getOS();
    this.params.state.persistentValues.APP_VERSION = environment.appVersion;
    this.params.state.persistentValues.ALLOW_HRV =
      ((environment?.appDesignSettings?.allowHRV ?? true)
        && (
          this.params.state.persistentValues.SCANNER_VERSION === 2
          || this.params.state.persistentValues.CONNECTION_TYPE === 'WIFI'
        )
      );
    this.params.state.appSettings = this.params.apiBasicService.getSettings();


    if (this.params.platform.is('cordova')) {
      if (this.params.platform.is('android')) {
        this.setState(State.PLATFORM, 'mobile-android');
      } else {
        this.setState(State.PLATFORM, 'mobile-ios');
      }
    } else {
      if (navigator.userAgent.includes('Windows')) {
        this.setState(State.PLATFORM, 'desktop-windows');
      } else if (navigator.userAgent.includes('Linux')) {
        this.setState(State.PLATFORM, 'desktop-linux');
      } else {
        this.setState(State.PLATFORM, 'desktop-mac');
      }
    }

    this.params.step = environment.appDesignSettings?.initialStage;
    this.params.numMeasurements = environment.appDesignSettings?.numMeasurementsAox ?? 4;
    this.params.media = {};
    this.params.blockScreen = false;

    if (!this.params.step) {
      return;
    }
    this.resetPage(this.params.step);

  }

  /**
   * initialize a measurement process
   * this.params method clears all prior subscriptions,
   * @param skipTo if provided, skip to the first occurrence of a given stage in the pipeline
   */
  resetPage = (skipTo: string) => {
    try { this.subscriptions.unsubscribe(); } catch (e) { }

    // this.params.subscriptions = new Subscription();
    this.subscriptions = new Subscription();

    // attempt to load aox data and measurement results from the state in case they are empty
    this.params.aoxData = this.params.aoxData.length === 0 ? [] : this.params.aoxData;
    this.params.measurements = this.params.measurements ?? [];

    this.params.stateObj = { _measurements: this.params.measurements, _aoxData: this.params.aoxData };

    // reset progress bars
    this.resetProgress();
    this.params.idx = this.params.aoxData.length;
    this.executeStage(
      skipTo,
      'Init'
    );
  }


  /**
   * get an object containing all variables stored in the 'valuesToSend'-subobject,
   * used to send via post-iframes
   */
  getSendState = () => {
    return JSON.stringify(this.params.state?.valuesToSend ?? {});
  }


  /**
   * callback function for the 'getState'-method
   * needed to give access to this.params within the main routine
   * @param key key of the state that is to be fetched
   * @returns value of the state
   */
  getState = (key: State): any => {
    return this.params.state.persistentValues[key];
  }

  /**
   * get the currently active network type
   */
  getNetworkType = () => {
    return this.params.platform.is('cordova') ? this.params.network.type : 'none';
  }

  getProgress = (index: number) => {
    if (index > -1) {
      return this.params.progress[index] ?? 0;
    }
    return this.params.progress.filter((v) => v > 0)?.pop() ?? 0;
  }

  getProgressStatus = (index: number) => {
    if (index > -1) {
      return this.params.barIsMeasured[index] ?? false;
    }
    if (index === -1) {
      return false;
    }
    return true;
  }

  pushToLog = async (msg: any, group = 'system') => {
    let log = [];
    switch (group) {
      case 'scanner': {
        if (!environment.appDesignSettings.logScanner) {
          return;
        }
        log = readAppLogs('scanner');
        log.push(msg);
        if (log.length > 500) {
          sendLogs(this.params.serial ?? 'None entered', log, undefined, undefined, undefined, 'scanner').then((val) => {
            console.log('Logs sent.');
          });
          log = [];
        }
        replaceAppLogs(log, 'scanner');
        break;
      }
      default:
      case 'system': {
        if (!environment.appDesignSettings.logSystem) {
          return;
        }
        log = readAppLogs('system');
        if (log.length > 1000) {
          log = await sendLogsSystem(
            this.params.serial ?? 'None entered',
            log,
            this.params.state.persistentValues.SCANNER_STATUS,
            this.params.state.persistentValues.PLATFORM,
            this.params.state.persistentValues.CONNECTION_TYPE,
          );
        }
        log.push(msg);
        replaceAppLogs(log, 'system');
        break;
      }
    }
  }

  /**
   * callback function for the 'setState'-method
   * needed to give access to this.params within the main routine
   * @param key key of the state that is to be written
   * @param val value of the given key
   */
  // setState = (key: State, val: any) => {
  //     this.params.state.persistentValues[key] = val;
  //     this.params.cd.detectChanges();
  // }
  closeKeyboardByBlur() {
    const activeElement = document.activeElement as HTMLElement;
    // return;
    if (activeElement && typeof activeElement.blur === 'function') {
      activeElement.blur();
    }
  }

  /**
   * callback function to set the local stage-input-variables
   * @param key key of the local input to be set
   * @param val value of the input
   */
  setStateObj = (key: string, val: any) => {
    this.params.stateObj[key] = val;
    this.params.cd.detectChanges();
  }

  setProgress = (idx: number, progress: number) => {
    this.params.progress[idx] = progress;
    this.params.state.persistentValues[State.MEASUREMENT_PROGRESS] = (Math.round(progress * 100));
    this.params.state.persistentValues[State.MEASUREMENT_PROGRESS_PERCENT] = `${(Math.round ( progress * 100 ))}%`;
  }

  /**
   * callback function to update the view config of the current page
   * if a new step is provided, reset all other view-specific variables unless they are specified otherwise
   * @param config config file, containing all to-be-set variables for the current page
   */
  setStep = async (config: {
    step?: string,
    instructionLink?: string,
    progress?: number,
    measurement?: any,
    idx?: number,
    aoxData?: AoxMeasurementResult[],
    delete?: boolean
    hrvMeasurement?: any,
    hrvProgress?: number,
    hrvDelete?: boolean,
    numMeasurements?: number
    result?: ResultType,
    scanner?: ScannerStatus,
  }, render = true) => {
    if (config.step && render) {
      // TODO: Do this.params later
      // currently, after launching the app, the home screen is visible for a second
      // before the setup menu launches
      this.params.lastRenderedPage = config.step;
      this.calcElements(config.step);
    }
    this.params.step = config.step ?? this.params.step;
    if (config.step) {
      this.params.currentDesign = environment?.appDesignConfigs[config.step]?.design?.template ?? '';
    }
    this.params.instructionLink = config.instructionLink ?? (config.step ? '' : this.params.instructionLink);
    this.params.idx = (config.idx !== undefined) ? config.idx : this.params.idx;
    if (config.idx !== undefined && config.progress !== undefined) { this.throttledFn(config.idx, config.progress); }
    if (config.idx !== undefined && config.measurement !== undefined) {
      this.params.measurements[config.idx] = config.measurement;
    }
    if (config.aoxData) {
      this.params.aoxData = config.aoxData;
    }
    if (config.idx !== undefined && config.progress === 1) {
      if (!this.params.barIsMeasured[config.idx]) {
      }
      this.params.barIsMeasured[config.idx] = true;
      this.setState('measurement_idx', config.idx + 1, 'temp');
    }

    if (config.idx !== undefined && config.delete) {
      this.params.idx -= 1;
      this.params.measurements.splice(this.params.idx, 1);
      const lastTrue = this.params.barIsMeasured.lastIndexOf(true);
      this.params.barIsMeasured[lastTrue] = false;
      // this.params.measurements.push(undefined);
    }


    if (config.hrvProgress) {
      this.params.hrvProgress = config.hrvProgress;
      if (config.hrvProgress === 1) {
        this.params.hrvBarIsMeasured = true;
      }
    }
    if (config.hrvMeasurement) {
      this.params.hrvMeasurement = config.hrvMeasurement;
    }
    if (config.hrvDelete) {
      this.params.hrvBarIsMeasured = false;
      this.params.hrvProgress = 0;
    }

    if (config.numMeasurements) {
      this.params.numMeasurements = config.numMeasurements;
    }
    if (config.result) {
      // await this.params.setState(State.RESULT, config.result, 'temp');
      this.params.result = config.result;
    }

    if (config.scanner) {
      this.params.scanner = { online: true, ...config.scanner };
      await this.setState(State.SCANNER_KEY, JSON.stringify(config.scanner), 'persistentValues');
      await this.setState(State.SCANNER_SERIAL, config.scanner.serial, 'persistentValues');
    }

    this.params.stateObj._aoxData = this.params.aoxData;
    this.params.stateObj._measurements = this.params.measurements;
    this.params.cd.detectChanges();
  }

  /**
   * callback function to retrieve all measurement-specific variables
   * @returns object containing all useful local variables
   */
  getStep = (): {
    result: ResultType;
    serial: string;
    step: string;
    aox: AoxMeasurementResult[];
    idx: number;
    measurements: any[];
    hrvMeasurement: HrvMeasurementData
    numMeasurements: number
  } => {
    return {
      serial: this.params.serial,
      measurements: this.params.measurements,
      hrvMeasurement: this.params.hrvMeasurement,
      numMeasurements: this.params.numMeasurements,
      aox: this.params.aoxData,
      idx: this.params.idx,
      result: this.params.result,
      step: this.params.step,
    };
  }

  /**
   * reset all progress bars up to the latest measurement that has been processed by the server
   */
  resetProgress = () => {
    this.params.progress = Array(this.params.numMeasurements).fill(0);
    this.params.barIsMeasured = Array(this.params.numMeasurements).fill(false);
    if (this.params.measurements.length > 0) {
      for (let i = 0; i < this.params.measurements.length; i++) {
        this.params.barIsMeasured[i] = true;
      }
    }
    if (this.params.aoxData.length > 0) {
      for (let i = 0; i < this.params.aoxData.length; i++) {
        this.params.progress[i] = 1;
      }
    }
  }

  /**
   * reset the entire measurement progress, and clear all arrays
   */
  resetAll = () => {
    this.params.measurements = [];
    this.params.aoxData = [];
    this.params.stateObj = { _measurements: this.params.measurements, _aoxData: this.params.aoxData };
    this.params.idx = 0;
    this.params.state.temp = {};
    this.params.state.persistentValues.AOX_MEASUREMENT_RESULTS = [];
    this.params.state.persistentValues.HRV_MEASUREMENT_RESULT = undefined;
    this.resetProgress();
  }

  /**
   * process a thrown error by writing several states, then going to the error page
   * @param error identifier of the error
   * @param restart currently unused
   */
  showErrorPage = async (error: string, restart: boolean): Promise<void> => {

    // current page ID in case of a 'go back'-call
    this.params.state.persistentValues.REFERRER = this.params.router.url;
    // code of the error
    this.params.state.persistentValues.ERROR_CODE = error;

    if (restart) {
    }
    this.params.router.navigateByUrl('/error/' + error);
  }

  /**
   * create an object containing all the needed callback functions, as well as some configs and variables
   * @returns created arguments object
   */
  getArgs = (): PipelineStageConfig => {
    const stageConfig: AppSettings = environment?.appDesignConfigs[this.params.step].settings ?? {};
    return {
      config: this.params.apiBasicService.getConfiguration(),
      stageConfig,
      numMeasurements: this.params.numMeasurements,
      networkType: this.params.networkType,
      getNetworkType: this.getNetworkType,
      reduceQueries: this.getState(State.REDUCE_WIFI_QUERYS),
      getStep: this.getStep,
      setStep: this.setStep,
      getState: this.getState,
      // setState: this.params.setState,
      setStateObj: this.setStateObj,
      setState: this.setState,
      clearState: this.clearState,
      executeStage: this.executeStage,
      resetProgress: this.resetProgress,
      resetAll: this.resetAll,
      fetchAppConfig: this.fetchAppConfig,
      skipRefresh: this.skipRefreshForConfigChecker,
      pushToLog: this.pushToLog,
      idx: this.params.idx,
      iab: this.params.iab,
      // state: this.params.state.persistentValues,
      state: this.params.state,
      scanner: this.params.scanner,
      // TODO: Replace this.params
      translate: this.translateWrapper,
      setBlockScreen: this.setBlockScreen,
      showToast: this.showToast,
    };
  }

  translateWrapper = (e: string) => {
    return translateString(e, this.params.languageStore);
  }

  showToast = (message: string, duration: number = 10000, position: 'top' | 'bottom' | 'middle' = 'top') => {
    this.params.toastCtrl.create({
      message,
      duration,
      position
    }).then((toast) => {
      toast.present();
    });
  }

  promptURL = async (url: string) => {
    return new Promise(async (resolve, reject) => {
      const alert = await this.params.alertCtrl.create({
        header: url,
        message: this.translateWrapper('URL_ALERT_MESSAGE'),
        backdropDismiss: false,
        buttons: [
          {
            text: this.translateWrapper('URL_ALERT_DECLINE'),
            handler: () => {
              alert.dismiss().then(() => {
                resolve(false);
              });
              return false;
            }
          }, {
            text: this.translateWrapper('URL_ALERT_ACCEPT'),
            handler: () => {
              alert.dismiss().then(() => { resolve(true); });
              return false;
            }
          }
        ]
      });

      await alert.present();

    });
  }


  /**
   * build a measurement pipeline with a single stage, and subscribe to it
   * @param stage string name of the next state to execute
   * otherwise, measure -> send -> measure -> send -> ...
   * @param msg method/trigger used to call this.params stage
   * @param callingStage if provided, check whether this.params stage is still active. if not, abort
   */
  executeStage = async (stage: string, msg: string, callingStage?: string) => {
    if (!this.alive) {
      try { this.subscriptions.unsubscribe(); } catch (e) { }
      delete this.subscriptions;
      return;
    }
    this.params.lock = true;
    await this.executeStageLogic(stage, msg, callingStage);
    this.params.lock = false;
  }

  executeStageLogic = async (stage: string, msg: string, callingStage?: string) => {
    console.log(stage);
    this.closeKeyboardByBlur();

    this.pageInit = Date.now();
    this.params.state.persistentValues.INDEX = this.params.idx;
    this.params.state.persistentValues[State.MEASUREMENT_PROGRESS] = 0;
    this.params.state.persistentValues[State.MEASUREMENT_PROGRESS_PERCENT] = '';
    const pageVideo: AppConfig = environment.appDesignConfigs?.[this.params.step];
    if (pageVideo?.design?.awaitVideo && msg !== 'click') {
      while (!this.params.videoFinished) {
        await new Promise(a => setTimeout(a, 10));
      }
    }
    this.params.videoFinished = true;

    const { stage: newStage, msg: newMsg, valid: isValid } = this.checkStage(stage, msg);

    if (!isValid) {
      return;
    }
    stage = newStage;
    msg = newMsg;

    try {
      // @ts-ignore
      // TODO: Maybe only do this one?
      window.navigator.splashscreen.hide();
    } catch (e) {
      //
    }

    if (!this.verifyBarcodeTimer(msg)) {
      return;
    }

    await this.dismissAlerts();

    // todo: reset progress bars here

    if (callingStage && callingStage !== this.params.step) {
      return;
    }
    await this.pushToLog({
      currentStage: this.params.step,
      nextStage: stage,
      timestamp: Math.floor(Date.now() / 1000),
      msg,
      type: 'msg'
    }, 'system');
    if (stage === '' || stage === undefined || stage === 'previousScreen') {
      return;
    }
    // on stage entry, unsubscribe to all lingering subscriptions, and create a new subscription
    try {
      try { this.subscriptions.unsubscribe(); } catch (e) { }
    } catch (e) {
      //
    }
    const { page, render, valid: isValidStage } = await this.getPage(stage);
    if (!isValidStage || !page) {
      return;
    }
    const urlPermitted = await this.permitURL(page);
    if (!urlPermitted) {
      return;
    }

    this.updatePageScrolling(page);

    if (environment.media) {
      this.params.media = environment.media;
    }
    await this.updatePageOrientation(page, render, stage);
    const { status: homePageValid, nextStage, message } = await this.handleHomePage(stage);
    if (!homePageValid) {
      if (nextStage && nextStage !== '') {
        this.executeStage(nextStage, message);
      }
      return;
    }

    this.genPipeline(page);

    this.checkBarcode();
    // ToDo: As of now, this is Wip and disabled. Come back to this later
    // this.checkUSB();
  }

  checkStage = (stage: string, msg: string) => {
    if (stage === 'previousScreen') {
      const stagesFiltered = this.params.stageHistory.filter((s) => s !== this.params.step);
      if (stagesFiltered.length >= 1) {
        stage = stagesFiltered[stagesFiltered.length - 1];
      }
    } else if (stage === 'DO_NOT_GO_TO_ANY_PAGE') {
      return { stage, msg, valid: false };
    } else if (!stage) {
      stage = environment.appDesignSettings.homeStage;
      msg += ' - Error: Stage does not exist. Returning to home-page';
    }
    return { stage, msg, valid: true };
  }

  verifyBarcodeTimer = (msg: string) => {
    const now = Date.now();
    if (msg === 'scannedBarcode') {
      if ((now - this.params.lastEnter) < 1000) {
        return false;
      } else {
        this.params.lastEnter = now;
      }
    }
    return true;
  }

  dismissAlerts = async () => {
    let alert = await this.params.alertCtrl.getTop();
    while (alert) {
      await alert.dismiss();

      alert = await this.params.alertCtrl.getTop();
    }
  }

  getPage = async (stage: string) => {
    let page: AppConfig = environment.appDesignConfigs?.[stage];

    // check whether a stageConfig and a design exist for the currently selected stage
    // if so, display the design
    if (!page) {
      this.resetAll();
      if (stage !== environment.appDesignSettings.homeStage) {
        this.executeStage(environment.appDesignSettings.homeStage ?? '', 'missing page');
      }
      return { page: undefined, valid: false, render: false };
    }

    page = fillConfig(page, environment.appDesignTemplates ?? {}, environment.appDesignTemplatesElements ?? {});
    let render = false;
    if (page?.design?.backgroundSize?.width !== undefined && page?.design?.backgroundSize?.height !== undefined
      && page.design.backgroundSize.width > 0 && page.design.backgroundSize.height > 0
    ) {
      render = true;
    }
    return { page, valid: true, render };
  }

  permitURL = async (page: AppConfig) => {
    const postURL = getPostURL(page);
    const isArr = Array.isArray(this.params.state.persistentValues.acceptedURLs);
    if (postURL !== undefined && !((isArr ? this.params.state.persistentValues.acceptedURLs : []).includes(postURL))) {
      const x = await this.promptURL(postURL);
      if (x) {
        if (!isArr) {
          this.params.state.persistentValues.acceptedURLs = [postURL];
        } else {
          this.params.state.persistentValues.acceptedURLs.push(postURL);
        }
      } else {
        this.params.toastCtrl.create({
          message: this.translateWrapper('PRIVACY_REQUIRED_TO_PROCEED'),
          duration: 10000,
          position: 'top'
        }).then((toast) => {
          toast.present();
        });
        this.executeStage(environment.appDesignSettings.homeStage ?? '', 'Did not accept privacy query');
        return false;
      }
    }
    return true;
  }

  updatePageScrolling = (page: AppConfig) => {
    const element = document.getElementsByTagName('app-precision')[0];
    if (element) {
      element.classList.remove(...['app-scroll-x', 'app-scroll-y', 'app-scroll']);
      let newScroll = '';
      const scrollX = page.design?.scroll?.scrollX ?? false;
      const scrollY = page.design?.scroll?.scrollY ?? false;
      if (scrollX && scrollY) {
        newScroll = 'app-scroll';
      } else if (scrollX) {
        newScroll = 'app-scroll-x';
      } else if (scrollY) {
        newScroll = 'app-scroll-y';
      }
      if (newScroll !== '') {
        element.classList.add(newScroll);
      }
    }
  }

  updatePageOrientation = async (page: AppConfig, render: boolean, stage: string) => {
    if (page.design && page.settings) {
      if (render) {
        this.params.stageHistory.push(stage);
        this.params.stageHistory = this.params.stageHistory.slice(-5);
        if (this.params.platform.is('cordova')) {
          if (page.design.orientation?.lock ?? true) {
            let orientation = this.params.screenOrientation.ORIENTATIONS.PORTRAIT;
            switch (page.design.orientation?.value) {
              case 'portrait': orientation = this.params.screenOrientation.ORIENTATIONS.PORTRAIT; break;
              case 'portrait-primary': orientation = this.params.screenOrientation.ORIENTATIONS.PORTRAIT_PRIMARY; break;
              case 'portrait-secondary': orientation = this.params.screenOrientation.ORIENTATIONS.PORTRAIT_SECONDARY; break;
              case 'landscape': orientation = this.params.screenOrientation.ORIENTATIONS.LANDSCAPE; break;
              case 'landscape-primary': orientation = this.params.screenOrientation.ORIENTATIONS.LANDSCAPE_PRIMARY; break;
              case 'landscape-secondary': orientation = this.params.screenOrientation.ORIENTATIONS.LANDSCAPE_SECONDARY; break;
            }
            if (!this.params.orientationLock || this.params.orientationValue !== orientation) {
              await this.params.screenOrientation.lock(orientation);
              this.params.orientationLock = true;
              this.params.orientationValue = orientation;
            }
          } else {
            this.params.screenOrientation.unlock();
            this.params.orientationLock = false;
          }
        }
      }
      await this.setStep({ step: stage }, render);
    }

    if (render) {
      this.shrinkText();
      await new Promise(a => setTimeout(a, 10));
      // allow for iFrame posts to be executed again
      this.params.didPostIframe = false;
    }
  }

  handleHomePage = async (stage: string) => {
    if (stage === environment.appDesignSettings.homeStage) {
      this.setBlockScreen(true);
      let log = readAppLogs('system');
      if (log.length > 1 && log.filter((l) => l.msg !== 'Timeout').length > 0 && !(environment.appDesignSettings.offlineConfig)) {
        const newLogs = await sendLogsSystem(
          this.params.serial ?? 'None entered',
          log,
          this.params.state.persistentValues.SCANNER_STATUS,
          this.params.state.persistentValues.PLATFORM,
          this.params.state.persistentValues.CONNECTION_TYPE
        );
        // this.setBlockScreen(false);
        if (newLogs.length === 0) {
          console.log('Logs sent.');
          clearAppLogs('system');
        } else {
          console.log('Could not send logs.');
        }
      } else {
        clearAppLogs('system');
      }

      let logScanner = readAppLogs('scanner');
      clearAppLogs('scanner');
      if (logScanner.length > 1 && !(environment.appDesignSettings.offlineConfig)) {
        sendLogs(this.params.serial ?? 'None entered', logScanner, undefined, undefined, undefined, 'scanner').then((val) => {
          console.log('Logs sent.');
        });
      }


      const { status, nextStage, message } = await this.stageValidator();
      this.params.networkType = this.getNetworkType();

      if (this.params.platform.is('cordova')) {
        await this.params.insomnia.allowSleepAgain();
      }

      if (!this.params.state.persistentValues.LICENSE || (
        (this.params.state.persistentValues.LICENSE.measurements?.aox || 0) === 0 &&
        (this.params.state.persistentValues.LICENSE.measurements?.aoxPrecise || 0) === 0 &&
        (this.params.state.persistentValues.LICENSE.measurements?.hrv || 0) === 0 &&
        (this.params.state.persistentValues.LICENSE.measurements?.vitality || 0) === 0
      )) {
        const licenseStr = localStorage.getItem('licenseData');
        if (licenseStr) {
          try {
            const licenseObj: License = JSON.parse(licenseStr);
            licenseObj.measurements = {
              aox: 0,
              aoxPrecise: 0,
              hrv: 0,
              vitality: 0,
            };
            this.params.state.persistentValues.LICENSE = licenseObj;
          } catch (e) {
            delete this.params.state.persistentValues.LICENSE;
          }
        } else {
          delete this.params.state.persistentValues.LICENSE;
        }
      }


      this.setBlockScreen(false);
      if (!status) {
        return { status, nextStage, message };
      }
    } else {
      if (stage === environment.appDesignSettings.initialStage) {
        if (!this.params.state.persistentValues.SELECTED_LANGUAGE) {
          let languageCode = (Object.keys(languageCodes).find(e => e.toLowerCase() === (window?.navigator?.language ?? '').toLowerCase()));
          if (!languageCode) {
            languageCode = (Object.keys(languageCodes).find(e => e.toLowerCase().startsWith((window?.navigator?.language ?? '').toLowerCase().slice(0, 2))));
            if (languageCode === 'EN-GB') {
              languageCode = 'EN-US';
            }
          }
          if (languageCode) {
            this.setState(State.SELECTED_LANGUAGE, languageCode);
            this.params.languageStore = environment.appDesignLanguages?.[this.params.state.persistentValues.SELECTED_LANGUAGE
            ?? this.params.apiBasicService.getConfiguration().defaultLang] ?? {};
          }
        }

      }

      if (this.params.platform.is('cordova')) {
        await this.params.insomnia.keepAwake();
      }
    }
    return { status: true, nextStage: '', message: '' };
  }

  genPipeline = (page: AppConfig) => {
    // TODO: Validate this.params
    const timeout = Number(page.settings.timeout?.timer ?? '');
    const args = this.getArgs();

    // create a pipeline with 1-3 stages, with the last always being the error handler
    const { pipeline, isStage } = this.params.genConfigService.parsePipelineConfig(
      page.settings.callFunction,
      args,
    );

    // if a stage doesn't have a design attached to it, nor a method to execute, it's configured improperly
    // display an error screen with the stage name as the error code
    if (!isStage && !page.design) {
      return;
    }
    pipeline.push(this.params.genConfigService.errorWrapper(args));
    try {
      try { this.subscriptions.unsubscribe(); } catch (e) { }
    } catch (e) {
      //
    }
    // this.params.subscriptions = new Subscription();
    this.subscriptions = new Subscription();
    this.params.lock = false;

    this.subscriptions.add(of(this.params.stateObj).pipe(
      pipe.apply(this.params, pipeline)
    ).subscribe());

    if (timeout) {
      const pipelineTimeout = this.params.genConfigService.parsePipelineTimeout(
        args,
        timeout > 0 ? timeout : undefined,
        page.settings.timeout?.onExpiration
      );
      this.subscriptions.add(of(this.params.stateObj).pipe(
        pipe.apply(this.params, pipelineTimeout)
      ).subscribe());
    }
  }

  openLink(link: string) {
    this.params.iab.create(link, '_system');
  }

  /**
   * set a local state variable
   * if a language is set, use it for the translation service
   * method used for html-inputs
   * @param key key under which to store the value
   * @param val value to store
   * @param group optional group to store the key in
   * @param isRadio is true, disable all other radio buttons on the page
   * @param buttonGroup if isRadio is set, all buttons in the same group will be disabled
   */
  setState = (key: string, val?: any, group: string = 'persistentValues', isRadio = false, buttonGroup = '', type = '') => {
    if (!this.params.state[group]) {
      this.params.state[group] = {};
    }
    let newVal = val;
    if (!newVal) {
      if (type === 'string') {
        newVal = '';
      } else if (type === 'number') {
        newVal = Number(newVal);
      } else if (newVal !== false) {
        newVal = !getKeyVal(`${group}.${key}`, this.params.state);
      }
    } else if (type === 'number') {
      if (!isNaN(Number(newVal))) {
        newVal = Number(newVal);
      }
    }
    setKeyVal(this.params.state, `${group}.${key}`, newVal);
    this.params.cd.detectChanges();

    if (isRadio) {
      const design: AppDesign = environment?.appDesignConfigs[this.params.step].design;
      const targetElements: any[] = Object.values(this.params.elementConfig ?? {}).filter(
        (element: ElementDesign) => element.handleFunction?.buttonGroup === buttonGroup
      );
      for (const element of targetElements) {
        const elementKey = element.handleFunction.value;
        const elementGroup = element.handleFunction.group;
        if (
          !elementKey
          || elementKey === ''
          || !elementGroup
          || elementGroup === ''
          || (elementGroup === group && elementKey === key)
        ) { continue; }
        setKeyVal(this.params.state, `${elementGroup}.${elementKey}`, false);
      }
      setKeyVal(this.params.state, `${group}.selected.${buttonGroup}`, getKeyVal(`${group}.${key}`, this.params.state));

    }

    if (group === 'persistentValues') {
      // if (key === 'profile.isMe') {
      //     setKeyVal(this.params.state, `${group}.profile.isGuest`, false);
      //     setKeyVal(this.params.state, `${group}.profile.selected`, getKeyVal(`${group}.${key}`, this.params.state));
      // } else if (key === 'profile.isGuest') {
      //     setKeyVal(this.params.state, `${group}.profile.isMe`, false);
      //     setKeyVal(this.params.state, `${group}.profile.selected`, getKeyVal(`${group}.${key}`, this.params.state));
      // }
      if (key === 'SELECTED_LANGUAGE') {
        // languages are stored differently from the options
        // the languages codes are stored instead of the full name, i.e. 'EN-US' instead of 'English (US)'
        // the language codes from the config are translated into full names via the TranslationPipe
        // this.params part reverses that translation
        const languageCodes = getLanguageCodes(true);
        const v = languageCodes[val] ?? val;
        this.params.state.persistentValues.LANGUAGE_TAG = v.substring(0, 2).toLowerCase();
        this.params.state.persistentValues.SELECTED_LANGUAGE = v;
        this.params.languageStore = environment.appDesignLanguages?.[v
          ?? this.params.apiBasicService.getConfiguration().defaultLang] ?? {};

        localStorage.setItem('SELECTED_LANGUAGE', v);
      }
      localStorage.setItem('persistentValues', JSON.stringify(this.params.state.persistentValues));
      if (key === 'JWT' && (this.params.state.persistentValues?.SCANNER_SERIAL ?? '') !== '') {
        getLicense(this.params.state.persistentValues.SCANNER_SERIAL).then((license) => {
          if (license) {
            try {
              license.measurements = {
                aox: 0,
                aoxPrecise: 0,
                hrv: 0,
                vitality: 0,
              };
              this.params.state.persistentValues.LICENSE = license;
            } catch (e) {
              delete this.params.state.persistentValues.LICENSE;
            }
          } else {
            delete this.params.state.persistentValues.LICENSE;
          }
        });
      }
    }
    this.params.cd.detectChanges();
  }

  clearState = async (group: string) => {
    this.params.state[group] = {};
    this.params.cd.detectChanges();
  }

  /**
   * wrapper to call a function indicated by a given string, with up to one parameter
   * @param func name of the function that is to be called
   * @param val optional value to pass to the function
   */
  handleFunction = async (func: ElementDesign['handleFunction'], val?: string, goTo?: string, valList?: string[]) => {
    // if the given value came from a dropdown list, try to find all values in the language store that mapped to this.params value
    // if the list of keys have an intersection with the list of possible values before translation, use that intersection as a value
    const languageStore = {...getDefaultLanguageStore(), ...(this.params.languageStore ?? {})};
    if (valList) {
      const keys = Object.keys(languageStore ?? {}).filter(k => (languageStore ?? {})[k] === (val ?? ''));
      const filteredArray = keys.filter(value => valList.includes(value));
      if (filteredArray.length > 0) {
        val = filteredArray[0];
      }
    }

    if (!func) {
      return;
    }
    let valParsed = val ?? func.argument;
    if (valParsed === '') {
      valParsed = undefined;
    }
    switch (func.name) {
      case 'setState': {
        const isRadio = func.isRadio ?? false;
        const elemGroup = func.buttonGroup ?? '';
        await this.setState(func.value, valParsed, func.group, isRadio, elemGroup, func?.elementType);
        break;
      }
      case 'factoryReset': {
        await this.resetFactory();
        window.location.reload();
        break;
      }
      case 'refresh': {
        if (this.skipRefreshForConfigChecker()) {
          return;
        }
        await this.fetchAppConfig();
        break;
      }
      case 'shareResult': {
        this.shareResults();
        break;
      }
      case 'shareMeasurementResults': {
        this.shareMeasurementResults(false);
        break;
      }
      case 'shareCustomMeasurementResults': {
        this.shareMeasurementResults(true);
        break;
      }
    }

    if (goTo && goTo !== '') {
      this.executeStage(goTo, 'change');
    }
  }

  private skipRefreshForConfigChecker = (): boolean => {
    return this.params.checkerDataService?.isCheckerActive === true;
  }

  /**
   * check whether a given variable satisfies a given condition
   * can be used for equality-checks, or for 'notEmpty'-checks
   * @param elementName name of the element to check. this.params element should have proper conditions
   */
  checkElement = (elementName: string) => {
    const element = this.params.elementConfig[elementName];
    if (!element) {
      return false;
    }
    if (element?.condition?.displayAfter ?? 0 > 0) {
      if (element.condition.displayAfter > ((Date.now() - this.pageInit) / 1000)) {
        return false;
      }
    }
    if (!element.condition?.checkIf) {
      return true;
    }

    const groups: string[] = (element.condition.group ?? '').split(',');
    const keys: string[] = (element.condition.checkIf ?? '').split(',');
    const vals: string[] = (element.condition.equalsValue ?? '').split(',');

    const len = Math.min(groups.length, keys.length, vals.length);

    for (let i = 0; i < len; i++) {
      let valCleansed = vals[i];
      let falsy = false;
      if (valCleansed.startsWith('!')) {
        valCleansed = valCleansed.slice(1);
        falsy = true;
      }

      const key = `${groups[i]}.${keys[i]}`;
      let localVal = getKeyVal(key, this.params.state) ?? undefined;
      if (localVal === undefined) {
        if ([null, undefined, '', '$empty'].includes(valCleansed)) {
          if (falsy) {
            return false;
          }
          continue;
        } else if (!falsy) {
          return false;
        } else {
          localVal = '';
        }
      }
      if (valCleansed === '$notEmpty') {
        if ((typeof localVal === 'string' && localVal.length === 0) || localVal === false) {
          return false;
        }
        continue;
      } else if (valCleansed === '$empty') {
        if (!([undefined, null, ''].includes(localVal))) {
          return false;
        }
        continue;
      }
      // this.params comparison is very naive and probably improvable
      // a boolean, for instance, is parsed to a string, as the comparison-value in the config is also a string
      if (localVal.toString().toLowerCase() !== valCleansed.toString().toLowerCase()) {
        if (!falsy) {
          return false;
        }
      } else {
        if (falsy) {
          return false;
        }
      }
    }
    return true;
  }

  /**
   * do a factory reset. This includes clearing all storages, caches, and cookies
   */
  resetFactory = async () => {
    // noinspection ES6MissingAwait
    localStorage.clear();
    const store = new Storage({}, 'localstorage');
    await store.clear();
    environment.media = undefined;

    caches.keys().then(keys => {
      keys.forEach(key => caches.delete(key));
    });

    document.cookie = document.cookie.split(';').reduce((newCookie1, keyVal) => {
      const pair = keyVal.trim().split('=');
      if (pair[0]) {
        if (pair[0] !== 'path' && pair[0] !== 'expires') {
          newCookie1 += pair[0] + '=;';
        }
      }
      return newCookie1;
    }, 'expires=Thu, 01 Jan 1970 00:00:00 UTC; path:/;');
  }

  /**
   * fetch the latest config for the connected scanner, and optionally reload
   * @param reload if true, soft-refresh the page
   */
  fetchAppConfig = async (reload: boolean = false) => {
    let didFetch = true;
    if (!reload) {
      didFetch = await this.params.appConfigService?.load();
    }
    if (didFetch) {
      try { this.subscriptions.unsubscribe(); } catch (e) { }
      delete this.subscriptions;
      this.params.navigate('/download');
    } else {
      const missingMedia = Number(localStorage.getItem('missingMedia') ?? '');
      if (missingMedia) {
        try { this.subscriptions.unsubscribe(); } catch (e) { }
        delete this.subscriptions;
        this.params.navigate('/download');
      }
    }
  }

  shareMeasurementResults(custom = false) {
    try {
      if (!this.params.platform.is('cordova') || custom) {
        return;
      }
      const data = this.params.fileManager.downloadCsv(custom ? 'resultsCustom' : 'results');
      if (!data) {
        return;
      }

      // @ts-ignore
      const file = window.cordova.file;
      this.params.fileManager.writeCSV(data, 'results.csv').then(() => {
        // @ts-ignore
        window.plugins.socialsharing.share('Your biozoom result export.', 'Biozoom result file', `${file.externalDataDirectory}results.csv`);
      });
    } catch (e) {
      return;
    }
  }

  shareResults() {
    const res = this.params.state?.temp?.result;
    if (!res || !this.getStep().serial) {
      return;
    }
    try {
      const url = getResult(
        res,
        this.getStep().serial,
        this.params.apiBasicService.getConfiguration(),
        this.getState(State.SELECTED_LANGUAGE)
      );
      if (!this.params.platform.is('cordova')) {
        return;
      }
      const options = {
        subject: 'Biozoom vitality report',
        url,
        iPadCoordinates: '0,0,0,0'
      };

      const onSuccess = result => {
      };

      const onError = msg => {
        console.log('Sharing failed with message: ' + msg);
      };

      // @ts-ignore
      window.plugins.socialsharing.shareWithOptions(options, onSuccess, onError);
    } catch (e) {
      return;
    }
  }

  async reload() {
    const newTS = Date.now();
    const currentHour = Number(new Date(newTS).toLocaleString().split(' ')[1].split(':')[0]);
    let AMPMstring = new Date(newTS).toLocaleString().split(' ')[2];
    if (!AMPMstring) {
      if (currentHour >= 0 && currentHour < 12) {
        AMPMstring = 'AM';
      } else {
        AMPMstring = 'PM';
      }
    }
    const isAM = AMPMstring === 'AM';
    const previousHour = Number(new Date(this.params.lastTS ?? 0).toLocaleString().split(' ')[1].split(':')[0]);
    this.params.lastTS = newTS;
    if (previousHour !== currentHour && currentHour === 2 && isAM) {
      console.log('Reloading in 15...');
      await new Promise(a => setTimeout(a, 15000));
      console.log('Reloading now...');
      const initialHref = window.location.href;
      // @ts-ignore
      window.location = initialHref;
    }
    // console.log(currentHour, previousHour);
    // this.lastTS = Date.now();
    // console.log()

  }

  async checkUSBDevice() {
    let serial = '';
    if ((environment?.appDesignSettings?.askForUSB === undefined || environment?.appDesignSettings?.askForUSB)) {
      if (this.params.state.persistentValues.CONNECTION_TYPE === 'USB'
        || !this.params.state.persistentValues.CONNECTION_TYPE
        || this.params.state.persistentValues.CONNECTION_TYPE === '') {
        // connect to usb device
        let versionNumber: number;
        let _CONN: boolean;
        // this.setBlockScreen(true);
        [_CONN, serial, versionNumber] = await this.params.scannerApi.connectToScanner(
          this.params.state.persistentValues,
          this.setState,
          this.setBlockScreen,
          true,
        );
        // this.setBlockScreen(false);
        if (serial !== '' && serial) {
          this.setState(State.CONNECTION_TYPE, 'USB');
          this.setState(State.USB_MODE, true);
          this.setState(State.SCANNER_SERIAL, serial);
          this.setState(State.SCANNER_VERSION, versionNumber);
          //     this.setState(State.SCANNER_SERIAL, scanner.serial);
        }
        await new Promise((r) => setTimeout(r, 100));
      }
    }
    return serial;
  }

  ngOnDestroy = () => {
    try { this.subscriptions.unsubscribe(); } catch (e) { }
    delete this.subscriptions;
  }

  async ionViewWillLeave() {
    try { this.subscriptions.unsubscribe(); } catch (e) { }
    delete this.subscriptions;
  }

}
